<style scoped lang="scss">
  .wrap-primer{
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title{
      h3{
        font-size: 24px;
        font-weight: bold;
      }
    }
    .el-steps{
      width:400px;
    }
    .address{
      background: #F9F9F9;
      padding:15px 20px;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .remark{
      background: #F9F9F9;
      padding:15px 20px;
      margin-top: 20px;
    }
  }
  .total{
    background: #F0F0F0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .price-info{
      display: flex;
    }
    span{
      margin-right:30px;
      display: inline-flex;
      align-items: center;
    }
    .price{
      font-weight: bold;
      font-size: 20px;
      color: #014492;
      small{
        font-size: 12px;
        font-weight: normal;
      }
    }
    .el-button{
      font-size: 20px;
      padding:14px 20px;
    }
  }
  .detail-lists{
    display: flex;
    flex-wrap: wrap;
    li{
      width:25%;
      text-align: left;
      margin:5px 0;
    }
  }
</style>
<template>
  <div class="wrap wrap-primer" v-loading="submitLoading">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>基因合成订单确认</h3>
<!--          <p>未处理订单（<span class="text-primary">3</span>）</p>-->
          <div class="opera mt10">
            <span class="text-primary pointer mr20" @click="$router.push(`/tec/order_gene?id=${id}`)" v-show="(fromPage === 'order' && total) || fromPage !== 'order'"><span class="el-icon-edit"></span> 编辑</span>
            <span class="text-primary pointer" @click="bindDelete" v-show="fromPage === 'order' && total"><span class="el-icon-delete"></span> 删除</span>
          </div>
        </div>
        <el-steps :active="1" align-center>
          <el-step title="序列输入、定制化信息填写"></el-step>
          <el-step title="报价并确认订单"></el-step>
        </el-steps>
      </div>
      <qk-edit-address/>
      <div class="remark" v-show="remark && remark !== ''">{{remark}}</div>
      <el-table
        border
        class="mt20"
        :data="geneLists">
        <el-table-column
          type="expand">
          <template slot-scope="scope">
            <ul class="detail-lists">
              <li>基因名称：{{scope.row.name}}</li>
              <li>密码子优化：{{scope.row.codonOptimization ? '是' : '否'}}</li>
              <li>避免的酶切位点：{{scope.row.avoidedRestrictionSites}}</li>
              <li>交付量(ug)：{{baseMethods.qualityConverter(scope.row.deliverNum, 'ng', 'ug', 3)}}</li>
              <li>克隆点位：{{scope.row.modify5}}/{{scope.row.modify3}}</li>
              <li>表达宿主：{{scope.row.expressionHost}}</li>
              <li>保留的酶切位点：{{scope.row.conservedEnzymeDigestion}}</li>
              <li>交付类型：{{scope.row.deliverType ? deliverTypeEnums[scope.row.deliverType] : '-'}}</li>
              <li class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;">序列：</div>
                    {{scope.row.sequence.substr(0, 500)}}...
                    <div v-show="scope.row.sequence.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis">序列：{{scope.row.sequence  | geneServiceType2(scope.row.sequence)}}</div>
                </el-tooltip>
                <el-button type="primary" size="small"
                           v-clipboard:copy="scope.row.sequence"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">复制</el-button>
              </li>
              <li>基因合成服务：{{scope.row.geneServiceType | geneServiceType1(scope.row.geneServiceType)}}</li>
              <li>序列类型：{{ scope.row.sequenceType }}</li>
              <li class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;">5‘侧翼序列：</div>
                    {{scope.row.flankingSequence5.substr(0, 500)}}...
                    <div v-show="scope.row.flankingSequence5.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis"> 5‘侧翼序列：{{scope.row.flankingSequence5  | geneServiceType2(scope.row.flankingSequence5)}}</div>
                </el-tooltip>
                <el-button  type="primary" size="small" style="margin-right: 15px;"
                            v-clipboard:copy="scope.row.flankingSequence5"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError" >复制</el-button>
              </li>
              <li class="d-flex flex-align-center">
                <el-tooltip placement="top">
                  <div slot="content" style="text-align: justify; width: 300px;">
                    <div style="margin-bottom: 10px;">3‘侧翼序列：</div>
                    {{scope.row.flankingSequence3.substr(0, 500)}}...
                    <div v-show="scope.row.flankingSequence3.length > 500" style="margin-top: 10px;">当前预览长度最大为500，如果浏览不全请点击“复制</div>
                  </div>
                  <div class="flex-1 text-ellipsis"> 3‘侧翼序列：{{scope.row.flankingSequence3  | geneServiceType2(scope.row.flankingSequence3)}}</div>
                </el-tooltip>
                <el-button type="primary" size="small"
                           v-clipboard:copy="scope.row.flankingSequence3"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">复制</el-button>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          label="产品序号">
          <template slot-scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="基因名称">
        </el-table-column>
        <el-table-column
          label="单价(元)">
          <template slot-scope="scope">
            <span v-if="scope.row.chargesY">{{scope.row.chargesY | amount}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="total mt30">
        <div class="price-info" v-if="total">
          <span>结款后可得积分：{{integral | tableNone}}</span>
          <span>总金额：¥ {{total | amount}}</span>
          <span>应付金额：¥ {{total | amount}}</span>
        </div>
        <div class="price-info" v-else>
          <span>结款后可得积分：<span style="color: #13489D;font-weight:bold;">待询价</span></span>
          <span>总金额：<span style="color: #13489D;font-weight:bold;">待询价</span></span>
          <span>应付金额：<span style="color: #13489D;font-weight:bold;">待询价</span></span>
        </div>
        <el-button type="primary" @click="onsubmit('submit')" v-preventReClick v-if="total">确认并下单</el-button>
        <el-button type="primary" @click="onsubmit('unSubmit')" v-preventReClick v-else>提交咨询</el-button>
<!--        <el-button type="primary" :disabled="fromPage === 'order' && !total" @click="onsubmit('unSubmit')" v-preventReClick v-else>提交咨询</el-button>-->
      </div>
<!--      <p class="tr text-gray9 fz12 mt10">您所选择的产品中有需要我们的客服进行报价。如果您需要款速进行结算，请去除需要报价的产品。或者您可以直接点击”提交咨询“，我们的客服会在1个工作日内联系您。</p>-->
    </section>
  </div>
</template>

<script>
import { geneOrders, geneWorkOrder, geneOrdersDetails, delGeneOrder, genePrice,checkBlackList } from '@/services/api.index'
import {deliverTypeEnums} from "../../constants/enums";

export default {
  data () {
    return {
      deliverTypeEnums,
      submitLoading: false,
      geneLists: [],
      geneInfo: this.baseMethods.getLocalObj('geneInfo'),
      id: this.$route.query.id,
      fromPage: this.$route.query.fromPage,
      integral: 0,
      remark: '',
      total: 0,
      details: {}
    }
  },
  created() {
    this.getDetails()
    this.getGeneLists()
  },
  filters:{
    geneServiceType1(data){
      if(data === 'STANDARD'){
        return '标准基因合成'
      }
      if(data === 'SPEED'){
        return '快速基因合成'
      }
      if(data === 'ET_GENE'){
        return 'ETgene'
      }
    },
    geneServiceType2(data){
      return data.slice(0,4)
    }
  },
  methods: {
    getDetails () {
      geneOrdersDetails(this.id).then(res => {
        const value = res.data.value
        this.integral = value.integralNumber
        this.remark = value.remark
        this.total = value.amount
        this.details = res.data
      })
    },
    getGeneLists () {
      geneWorkOrder(this.id).then(async res => {
        this.geneLists = res.data
        // this.geneLists.map(item => {
        //   if (!item.value.charges) {
        //     this.total = '待报价'
        //   }
        // })
      })
    },
    // 提交订单
    async onsubmit (submitType) {
      // 提交前再次核对订单金额
      geneOrdersDetails(this.id).then(async res => {
        const value = res.data.value
        this.integral = value.integralNumber
        this.remark = value.remark
        this.total = value.amount
        this.details = res.data
        // 原提交逻辑
        const memberInfo = this.baseMethods.getLocalObj('memberInfo')
        const courseInfo = this.baseMethods.getLocalObj('courseInfo')
        let totalPrice = !this.total ? 0 : this.total
        //校验当前客户课题组是否被拉黑
        let {data}=await checkBlackList({customerId: memberInfo.id,type:"GENE"});
        if(data==false){
          // this.$alert('下单异常，请联系销售人员','提示',{ confirmButtonText: '确认'})
          this.$alert('下单异常,请电联4006683730转7','提示',{ confirmButtonText: '确认'})        
          return;
        }
        this.submitLoading = true
        let submitData = {
          id: this.id,
          // baseId: courseInfo.base.id,
          customerId: memberInfo.id,
          geneSaveVMList: this.geneLists,
          // 官网订单全部走报价模块
          submitFlag: true,
          priceFlag: submitType === 'unSubmit',
          amount: totalPrice,
          geneOrderReturnFlag:false,
          clientGrade: memberInfo.level,
          customerEmail: memberInfo.email,
          // researchTeamId: memberInfo.researchGroup.id,
          // serviceSalesId: memberInfo.serveSeller.id
        }
        submitData = Object.assign(submitData, this.baseMethods.getRaAddress())
        geneOrders(submitData).then(() => {
          this.submitLoading = false
          if (submitType === 'submit') {
            this.$message.success('下单成功')
            this.$router.push('/tec/success_submit?type=gene')
          } else {
            this.$message.success('提交成功')
            this.$router.push('/tec/success_submit?type=geneConsult')
          }
        })
      })      
     
    },
    // 删除
    bindDelete () {
      this.$confirm('确定删除此订单？', '提示', {
      }).then(() => {
        delGeneOrder(this.id).then(() => {
          this.$message.success('删除成功')
          this.baseMethods.hrefUrl('/user/gene')
        })
      })
    },
    // 复制序列号
    onCopy () {
      this.$message.success('复制成功！')
    },
    onError () {
      this.$message.error('复制失败！')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/gene_confirm.vue